import { getProductDefaultUom } from 'redux/modules/product-details/selectors/product-pricing';

export const getQuantityOrFixUom = (state, productId, quantity = {}) =>
  quantity.amount > 0 ? quantity : { amount: 0, uom: getProductDefaultUom(state, productId) };
